export const MANAGE_CYCLE_MENU_FETCHING = 'MANAGE_CYCLE_MENU_FETCHING';
export const MANAGE_CYCLE_MENU_SET_GRID_DATA =
  'MANAGE_CYCLE_MENU_SET_GRID_DATA';
export const MANAGE_CYCLE_MENU_FETCH_ERROR = 'MANAGE_CYCLE_MENU_FETCH_ERROR';
export const MANAGE_CYCLE_MENU_SET_SAVE_SUCCESSFUL =
  'MANAGE_CYCLE_MENU_SET_SAVE_SUCCESSFUL';
export const MANAGE_CYCLE_MENU_CLEAR_ERRORS = 'MANAGE_CYCLE_MENU_CLEAR_ERRORS';
export const MANAGE_CYCLE_MENU_SET_NEW_CYCLE_MENU =
  'MANAGE_CYCLE_MENU_SET_NEW_CYCLE_MENU';
export const MANAGE_CYCLE_MENU_SET_EDITING = 'MANAGE_CYCLE_MENU_SET_EDITING';
export const MANAGE_CYCLE_MENU_SET_EDIT_CYCLE_VALUES =
  'MANAGE_CYCLE_MENU_SET_EDIT_CYCLE_VALUES';
export const MANAGE_CYCLE_MENU_SET_DUPLICATING =
  'MANAGE_CYCLE_MENU_SET_DUPLICATING';
export const MANAGE_CYCLE_MENU_DUPLICATE_FETCHING =
  'MANAGE_CYCLE_MENU_DUPLICATE_FETCHING';
export const MANAGE_CYCLE_MENU_SET_SHARE_SUCCESS =
  'MANAGE_CYCLE_MENU_SET_SHARE_SUCCESS';
export const MANAGE_CYCLE_MENU_SHARE_ERROR = 'MANAGE_CYCLE_MENU_SHARE_ERROR';
export const MANAGE_CYCLE_MENU_GET_SHARED_DISTRICTS =
  'MANAGE_CYCLE_MENU_GET_SHARED_DISTRICTS';
export const MANAGE_CYCLE_MENU_GET_SHARED_DISTRICTS_ERROR =
  'MANAGE_CYCLE_MENU_GET_SHARED_DISTRICTS_ERROR';
export const MANAGE_CYCLE_MENU_SET_UNSHARE_SUCCESS =
  'MANAGE_CYCLE_MENU_SET_UNSHARE_SUCCESS';
export const MANAGE_CYCLE_MENU_UNSHARE_ERROR =
  'MANAGE_CYCLE_MENU_UNSHARE_ERROR';

export const MANAGE_CYCLE_MENU_GET_IS_PARENT_DISTRICT =
  'MANAGE_CYCLE_MENU_GET_IS_PARENT_DISTRICT';



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/listcycles/types.js